<template>
  <div class="hello">
  </div>
</template>

<script>
export default {
  name: 'TV1',
  data(){
    return {
      emuOWebtList:[]
    };
  },
  props: {
    msg: String
  },
  methods:{
    showAll(){
        let _this = this;
        this.$axios.post('/ssBaseS3Controller/watchTVat1.do',)
        .then(res => {
            _this.emuOWebtList = res.emuOWebtList;
        })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
